import { render, staticRenderFns } from "./MiniWizardStickyReward.vue?vue&type=template&id=0d60eaff&"
import script from "./MiniWizardStickyReward.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports